module.exports = __webpack_public_path__ + "img/pictures-icon.20800669.png";